import { COLORS } from "../../shared/constants";
import { IconBack } from "../../shared/icons";
import { useState } from "react";
import AssessmentScalesTab from "./AssessmentScalesTab";
import ClinicInfoTab from "./ClinicInfoTab";
import DevicesTab from "./DevicesTab";
import IpadsTab from "./IpadsTab";
import DiagnosesTab from "./DiagnosesTab";
import ImportExportTab from "./ImportExportTab";
import CalendarTab from "./CalendarTab";
import LookupTab from "./LookupTab";
import ProtocolForm from "../ProtocolForm";
import ProtocolList from "../ProtocolList";
import ProvidersTab from "./ProvidersTab";
import UsersTab from "./UsersTab";

export default // ─── Settings Screen ─────────────────────────────────────────
function SettingsScreen({ currentUser, clinicInfo, onSaveClinicInfo, users, onSaveUser, onDeactivateUser, providers, onSaveProvider, onDeleteProvider, coils, onSaveCoils, treatmentSpots, onSaveTreatmentSpots, mtSpots, onSaveMtSpots, diagnoses, onSaveDiagnoses, onNavigate, protocols, onCopyProtocol, onDeleteProtocol, onSaveProtocol, onReorderProtocols, assessmentScales, onSaveScale, onCopyScale, onDeleteScale }) {
  const [tab, setTab] = useState("clinic");
  const [editingProto, setEditingProto] = useState(null); // null = list view, "NEW" = new, object = editing
  const isMD = currentUser.role === "MD";

  const tabs = [
    { id: "clinic", label: "Clinic Info" },
    { id: "users", label: "Users" },
    { id: "providers", label: "Referring Providers" },
    { id: "protocols", label: "Stimulation Protocols" },
    { id: "coils", label: "Coils" },
    { id: "tspots", label: "Treatment Spots" },
    { id: "mspots", label: "MT Spots" },
    { id: "diagnoses", label: "Diagnoses / ICD-10" },
    { id: "scales", label: "Assessment Scales" },
    { id: "devices", label: "Devices" },
    { id: "ipads", label: "Paired iPads" },
    { id: "import", label: "Data Import / Export" },
    { id: "calendar", label: "Google Calendar" },
  ];

  return (
    <div style={{ padding: "24px", maxWidth: "1200px", margin: "0 auto" }}>
      <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "24px" }}>
        <button onClick={() => onNavigate("HOME")} style={{ background: "none", border: `1px solid ${COLORS.border}`, borderRadius: "8px", padding: "8px", cursor: "pointer", display: "flex", alignItems: "center", color: COLORS.textSecondary }}><IconBack /></button>
        <h2 style={{ color: COLORS.text, fontSize: "20px", fontWeight: "600", margin: 0 }}>Settings</h2>
      </div>
      <div style={{ display: "flex", gap: "20px" }}>
        {/* Sidebar */}
        <div style={{ width: "200px", flexShrink: 0 }}>
          {tabs.map((t) => (
            <button key={t.id} onClick={() => setTab(t.id)}
              style={{
                display: "block", width: "100%", textAlign: "left", padding: "10px 14px", marginBottom: "2px",
                borderRadius: "8px", border: "none", fontSize: "13px", fontWeight: tab === t.id ? "600" : "400",
                background: tab === t.id ? COLORS.primaryLight : "transparent",
                color: tab === t.id ? COLORS.primary : COLORS.textSecondary,
                cursor: "pointer",
              }}>
              {t.label}
            </button>
          ))}
        </div>
        {/* Content */}
        <div style={{ flex: 1, minWidth: 0, background: COLORS.surface, borderRadius: "12px", border: `1px solid ${COLORS.borderLight}`, padding: "24px", boxShadow: "0 1px 4px rgba(0,0,0,0.04)", overflow: "auto" }}>
          {tab === "clinic" && <ClinicInfoTab info={clinicInfo} onSave={onSaveClinicInfo} />}
          {tab === "users" && <UsersTab users={users} onSave={onSaveUser} onDeactivate={onDeactivateUser} isMD={isMD} />}
          {tab === "providers" && <ProvidersTab providers={providers} onSave={onSaveProvider} onDelete={onDeleteProvider} />}
          {tab === "protocols" && (
            editingProto !== null ? (
              <ProtocolForm
                protocol={editingProto === "NEW" ? null : editingProto}
                currentUser={currentUser}
                coils={coils}
                treatmentSpots={treatmentSpots}
                mtSpots={mtSpots}
                onSave={(p) => { onSaveProtocol(p); setEditingProto(null); }}
                onCancel={() => setEditingProto(null)}
                embedded
              />
            ) : (
              <ProtocolList
                protocols={protocols}
                currentUser={currentUser}
                onNavigate={onNavigate}
                onCopy={onCopyProtocol}
                onDelete={onDeleteProtocol}
                onEdit={(p) => setEditingProto(p)}
                onNew={() => setEditingProto("NEW")}
                onReorder={onReorderProtocols}
                embedded
              />
            )
          )}
          {tab === "coils" && <LookupTab title="Coils" items={coils} category="coils" onRefresh={onSaveCoils} />}
          {tab === "tspots" && <LookupTab title="Treatment Spots" items={treatmentSpots} category="treatment-spots" onRefresh={onSaveTreatmentSpots} />}
          {tab === "mspots" && <LookupTab title="Motor Threshold Spots" items={mtSpots} category="mt-spots" onRefresh={onSaveMtSpots} />}
          {tab === "diagnoses" && <DiagnosesTab diagnoses={diagnoses} onRefresh={onSaveDiagnoses} />}
          {tab === "scales" && <AssessmentScalesTab scales={assessmentScales || []} onSave={onSaveScale} onCopy={onCopyScale} onDelete={onDeleteScale} currentUser={currentUser} />}
          {tab === "devices" && <DevicesTab />}
          {tab === "ipads" && <IpadsTab />}
          {tab === "import" && <ImportExportTab />}
          {tab === "calendar" && <CalendarTab />}
        </div>
      </div>
    </div>
  );
}

// ─── Clinic Info Tab ──────────────────────────────

